"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionGroupConfigurationOutputType = exports.BotSkillAnswerValidationType = exports.BotSkillAnswerKeywordMatchType = exports.BotSkillAnswerOutputType = exports.BotSkillAnswerType = void 0;
var BotSkillAnswerType;

(function (BotSkillAnswerType) {
  BotSkillAnswerType["KEYWORDS"] = "KEYWORDS";
  BotSkillAnswerType["BUTTON"] = "BUTTON";
  BotSkillAnswerType["VALIDATE"] = "VALIDATE";
  BotSkillAnswerType["DEFAULT"] = "DEFAULT";
  BotSkillAnswerType["INVALIDATE"] = "INVALIDATE";
  BotSkillAnswerType["EMPTY_PATH"] = "EMPTY_PATH";
  BotSkillAnswerType["AI_TOPIC"] = "AI_TOPIC";
  BotSkillAnswerType["AI_DEFAULT"] = "AI_DEFAULT";
})(BotSkillAnswerType = exports.BotSkillAnswerType || (exports.BotSkillAnswerType = {}));

var BotSkillAnswerOutputType;

(function (BotSkillAnswerOutputType) {
  BotSkillAnswerOutputType["NONE"] = "NONE";
  BotSkillAnswerOutputType["SKIP"] = "SKIP";
})(BotSkillAnswerOutputType = exports.BotSkillAnswerOutputType || (exports.BotSkillAnswerOutputType = {}));

var BotSkillAnswerKeywordMatchType;

(function (BotSkillAnswerKeywordMatchType) {
  BotSkillAnswerKeywordMatchType["FUZZY"] = "FUZZY";
  BotSkillAnswerKeywordMatchType["EQUALS"] = "EQUALS";
  BotSkillAnswerKeywordMatchType["CONTAINS"] = "CONTAINS";
})(BotSkillAnswerKeywordMatchType = exports.BotSkillAnswerKeywordMatchType || (exports.BotSkillAnswerKeywordMatchType = {}));

var BotSkillAnswerValidationType;

(function (BotSkillAnswerValidationType) {
  BotSkillAnswerValidationType["EMAIL"] = "EMAIL";
  BotSkillAnswerValidationType["PHONE"] = "PHONE";
})(BotSkillAnswerValidationType = exports.BotSkillAnswerValidationType || (exports.BotSkillAnswerValidationType = {}));

var ActionGroupConfigurationOutputType;

(function (ActionGroupConfigurationOutputType) {
  ActionGroupConfigurationOutputType["NONE"] = "NONE";
  ActionGroupConfigurationOutputType["QUESTION"] = "QUESTION";
  ActionGroupConfigurationOutputType["GOAL"] = "GOAL";
  ActionGroupConfigurationOutputType["END_CONVERSATION"] = "END_CONVERSATION";
})(ActionGroupConfigurationOutputType = exports.ActionGroupConfigurationOutputType || (exports.ActionGroupConfigurationOutputType = {}));